import { z } from 'zod';

const envSchema = z.object({
  VITE_API_BASE_URL: z.url(),
  VITE_APP_NAME: z.string().default('SISMA'),
  VITE_NODE_ENV: z.enum(['development', 'production', 'staging']).default('development'),
  // When set to "true" in development, surfaces axe-core a11y violations in the
  // browser console while you navigate the app (see main.tsx).
  VITE_A11Y_AUDIT: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
  // When set to "true", reports Core Web Vitals (LCP, CLS, INP, FCP, TTFB)
  // to the browser console as the user navigates (see main.tsx).
  VITE_PERF_REPORT: z
    .enum(['true', 'false'])
    .default('false')
    .transform((v) => v === 'true'),
});

export const env = envSchema.parse(import.meta.env);

export type Env = z.infer<typeof envSchema>;
